"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unblockReceiverUser = exports.seeOptionsChat = exports.redirectUserToLoginPage = exports.redirectUserToKnowMorePage = exports.redirectUserToBannedUserHelp = exports.redirectUserToAIPage = exports.redirectToUserProfile = exports.redirectToResearchPlatformEvolution = exports.redirectToAd = exports.openTipLink = exports.denounceReceiverUser = exports.deleteCurrentChat = exports.blockReceiverUser = void 0;
var _chatActions = require("./chatActions");
var _selectors = require("../selectors");
var _modalActions = require("./modalActions");
var _partnersActions = require("./partnersActions");
var _adUtil = require("../helpers/adUtil");
var _linking = require("../helpers/linking");
var _errorActions = require("./errorActions");
var _exceptions = require("../exceptions");
// ====================================================================
// Functions actions
// ====================================================================

var redirectUserToBannedUserHelp = exports.redirectUserToBannedUserHelp = function redirectUserToBannedUserHelp() {
  return function () {
    var REACT_APP_BANNED_USER_HELP_URL = "https://chatmod-redirects.olxbr.com/queremos-sua-seguranca";
    (0, _linking.openLink)(REACT_APP_BANNED_USER_HELP_URL);
  };
};
var redirectUserToKnowMorePage = exports.redirectUserToKnowMorePage = function redirectUserToKnowMorePage() {
  return function () {
    (0, _linking.openKnowMoreLink)();
  };
};
var redirectUserToAIPage = exports.redirectUserToAIPage = function redirectUserToAIPage() {
  return function (_, __, _ref) {
    var Lurker = _ref.Lurker;
    (0, _linking.openInsertAdLink)(Lurker);
  };
};
var redirectUserToLoginPage = exports.redirectUserToLoginPage = function redirectUserToLoginPage() {
  return function (_, getState, _ref2) {
    var Lurker = _ref2.Lurker;
    var _getState = getState(),
      renderProps = _getState.renderProps;
    var _renderProps$listId = renderProps.listId,
      listId = _renderProps$listId === void 0 ? '' : _renderProps$listId,
      loginUrl = renderProps.loginUrl;
    Lurker.clickLoginButton();
    if (loginUrl) {
      (0, _linking.openLink)(loginUrl);
      return;
    }
    (0, _linking.openAccountsLoginLink)(listId);
  };
};
var redirectToAd = exports.redirectToAd = function redirectToAd() {
  return function (_, getState) {
    var chat = (0, _selectors.getCurrentChat)(getState());
    var listId = chat.listId,
      adStatus = chat.adStatus;
    if (listId && !(0, _adUtil.isAdInactive)(adStatus)) {
      (0, _linking.openAdPageLink)(listId);
    }
  };
};
var openTipLink = exports.openTipLink = function openTipLink(links, trackingParams) {
  return function (_, __, _ref3) {
    var Lurker = _ref3.Lurker;
    Lurker.clickTipAction(trackingParams);
    (0, _linking.openLink)(links);
  };
};
var redirectToUserProfile = exports.redirectToUserProfile = function redirectToUserProfile(errorFunction, hasMessages) {
  return function (dispatch, getState, _ref4) {
    var Lurker = _ref4.Lurker;
    try {
      var _getCurrentPartner = (0, _selectors.getCurrentPartner)(getState()),
        slug = _getCurrentPartner.slug,
        id = _getCurrentPartner.id;
      (0, _linking.openUserProfileLink)(slug !== null && slug !== void 0 ? slug : id, Lurker, hasMessages);
    } catch (ex) {
      if (ex.message === 'NO_INTERNET' && errorFunction) {
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var redirectToResearchPlatformEvolution = exports.redirectToResearchPlatformEvolution = function redirectToResearchPlatformEvolution(errorFunction, chatId, accountId, hasMessages) {
  return function (dispatch, getState, _ref5) {
    var Lurker = _ref5.Lurker;
    try {
      (0, _linking.openResearchPlatformEvolution)(chatId, accountId, Lurker, hasMessages);
    } catch (ex) {
      if (ex.message === 'NO_INTERNET' && errorFunction) {
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var blockReceiverUser = exports.blockReceiverUser = function blockReceiverUser(errorFunction) {
  return function (dispatch, getState, _ref6) {
    var _ = _ref6._,
      Lurker = _ref6.Lurker;
    try {
      var blockedId = (0, _selectors.getPartner)(getState());
      Lurker.clickBlockUserChat();
      Lurker.viewBlockUserSuccessful();
      dispatch((0, _partnersActions.blockUser)(blockedId));
    } catch (ex) {
      if (ex.message === 'NO_INTERNET') {
        Lurker.viewBlockUserSuccessful();
        Lurker.viewBlockUserWithNoInternet();
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        Lurker.viewBlockUserFailure(ex);
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var unblockReceiverUser = exports.unblockReceiverUser = function unblockReceiverUser(errorFunction) {
  return function (dispatch, getState, _ref7) {
    var _ = _ref7._,
      Lurker = _ref7.Lurker;
    try {
      var blockedId = (0, _selectors.getPartner)(getState());
      Lurker.clickUnblockUser();
      Lurker.viewUnblockUserSuccessful();
      dispatch((0, _partnersActions.unblockUser)(blockedId));
    } catch (ex) {
      if (ex.message === 'NO_INTERNET') {
        Lurker.viewUnblockUserSuccessful();
        Lurker.viewUnblockUserWithNoInternet();
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        Lurker.viewUnblockUserFailure(ex);
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var denounceReceiverUser = exports.denounceReceiverUser = function denounceReceiverUser(reason, errorFunction, reportType) {
  return function (dispatch, getState, _ref8) {
    var _ = _ref8._,
      Lurker = _ref8.Lurker;
    try {
      var denouncedId = (0, _selectors.getPartner)(getState());
      Lurker.clickReportUserChat(reportType);
      Lurker.viewReportUserSuccessful(reason, reportType);
      dispatch((0, _partnersActions.denounceUser)(denouncedId));
      dispatch((0, _modalActions.closeModal)());
    } catch (ex) {
      if (ex.message === 'NO_INTERNET') {
        Lurker.viewReportUserSuccessful(reason, reportType);
        Lurker.viewReportUserWithNoInternet(reason, reportType);
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        Lurker.viewReportUserFailure(reason, ex, reportType);
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var deleteCurrentChat = exports.deleteCurrentChat = function deleteCurrentChat(errorFunction) {
  return function (dispatch, getState, _ref9) {
    var _ = _ref9._,
      Lurker = _ref9.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    var roomname = (0, _selectors.getCurrentRoomname)(getState());
    try {
      Lurker.clickDeleteChat();
      Lurker.viewDeleteChatSuccessful(isFavorite);
      dispatch((0, _chatActions.removeCurrentChat)(roomname));
      dispatch((0, _modalActions.closeModal)());
    } catch (ex) {
      if (ex.message === 'NO_INTERNET') {
        Lurker.viewDeleteChatSuccessful(isFavorite);
        Lurker.viewDeleteWithNoInternet();
        dispatch((0, _modalActions.openModal)(errorFunction('NO_INTERNET')));
      } else {
        Lurker.viewDeleteChatFailure(ex);
        dispatch((0, _errorActions.handleError)(new _exceptions.UserActionException(errorFunction, ex)));
      }
    }
  };
};
var seeOptionsChat = exports.seeOptionsChat = function seeOptionsChat() {
  return function (_, __, _ref10) {
    var Lurker = _ref10.Lurker;
    Lurker.viewSeeOptionsChat();
  };
};